import { useAtom } from 'jotai';
import { useMemo } from 'react';
import { type StationFilterAtom } from '../atoms';

export const useStationFilter = (filterAtom: StationFilterAtom, stationNames: string[]) => {
    const [filter, setFilter] = useAtom(filterAtom);

    // Names persisted from an earlier session may no longer be reported, so only keep the ones we have options for.
    const selectedNames = useMemo(() => filter.filter((name) => stationNames.includes(name)), [filter, stationNames]);

    const handleSetFilter = (_: unknown, names: string[]) => {
        setFilter(names);
    };

    return { selectedNames, handleSetFilter };
};
